module.exports = __webpack_public_path__ + "fonts/fa-solid-900.22e3270b.woff";